{
  "version": 1,
  "asset_id": "008f02b9-c65b-4dd8-892e-325b5c5bde2f",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/008f02b9-c65b-4dd8-892e-325b5c5bde2f/palworld-booster-pack-dawn-of-palpagos-trim.png",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/008f02b9-c65b-4dd8-892e-325b5c5bde2f/palworld-booster-pack-dawn-of-palpagos-trim.png",
  "original_filename": "palworld-booster-pack-dawn-of-palpagos-trim.png",
  "size": 791273,
  "content_type": "image/png",
  "created_at": "2026-08-02T02:01:54Z"
}
